export default {"src":"/_next/static/media/468.11ccff1f.svg","height":77,"width":412,"blurWidth":0,"blurHeight":0};